import React, { useState, useEffect } from "react";
import Temoignage from "../Temoignages/temoignage";
import styles from "./Temoignage.module.css";

const ListeTemoignages = () => {
  const [temoignages, setTemoignages] = useState<
    { nom: string; role: string; note: number; commentaire: string; avatar?: string }[]
  >([]);
  useEffect(() => {
    const temoignagesEnregistres = JSON.parse(localStorage.getItem("temoignages") || "[]");
    setTemoignages(temoignagesEnregistres);
  }, []);

  const ajouterTemoignage = (nouveauTemoignage: {
    nom: string;
    role: string;
    note: number;
    commentaire: string;
    avatar?: string;
  }) => {
    const nouveauxTemoignages = [...temoignages, nouveauTemoignage];
    setTemoignages(nouveauxTemoignages);
    localStorage.setItem("temoignages", JSON.stringify(nouveauxTemoignages));
  };

  return (
    <section className={styles.listeTemoignages}>
      <h3 className={styles.sousTitre}>Des voix du terrain</h3>
      <h2 className={styles.titre}>L’impact de notre solution en témoignages</h2>

      {temoignages.length === 0 ? (
        <p className={styles.aucunTemoignage}>Aucun témoignage disponible.</p>
      ) : (
        <div className={styles.sliderTemoignages}>
          {temoignages.map((temoignage, index) => (
            <Temoignage key={index} {...temoignage} />
          ))}
        </div>
      )}
    </section>
  );
};

export default ListeTemoignages;
